export default __webpack_public_path__ + "locales/ar-SA/ResetApplicationDialog.json?hash=ad2bb3bd5af8ba6895f07d0e7b4e3781";